import React from 'react';
import { useLanguage } from '~/Hooks';
import { PrivateLayout } from '~/Layout/PrivateLayout';
import ServiceTile from './ServiceTile';

export const ActivateVideoOnDemand = () => {
  const { t } = useLanguage();
  return (
    <PrivateLayout title={t('app.vod.activate')} hideBackButton articleLink="app.vod">
      <ServiceTile />
    </PrivateLayout>
  );
};
